import { render, staticRenderFns } from "./MOM_SettingsWindow.vue?vue&type=template&id=5d72a9d2&scoped=true"
import script from "./MOM_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./MOM_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d72a9d2",
  null
  
)

export default component.exports